import { Helmet } from "react-helmet";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Collapse,
  Chip,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import { makeStyles, styled } from "@mui/styles";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import DropZone from "../../../../components/DropZone";
import CloseIcon from "../../../../assets/images/plus-circle-fill.svg";
import AttachFilesDialog from "../../../../components/achievement/AttachFilesDialog";
import InputForm from "../../../../components/achievement/InputForm";
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";

import { ReactComponent as PencilWhiteIcon } from "../../../../icons/pencil-white.svg";
import { ReactComponent as PlusIcon } from "../../../../icons/plus.svg";
import { ReactComponent as TrashIcon } from "../../../../assets/images/portfolio/trash-alt.svg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import fileBrowser from "../../../../icons/file-browser.svg";
import cssVariables from "../../../../theme/cssVariables";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as PdfIcon } from "../../../../assets/images/iconFile/pdf.svg";
import { ReactComponent as JpgIcon } from "../../../../assets/images/iconFile/jpg.svg";
import { ReactComponent as PngIcon } from "../../../../assets/images/iconFile/png.svg";
import { ReactComponent as NullIcon } from "../../../../assets/images/iconFile/Null-File.svg";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import Icon from '@mui/material/Icon';

import {
  getAchievementEdit,
  postAchievementEdit,
  deleteAchievement,
  getAchievementFiles,
  deleteFileAchievement,
  getFileDetail
} from "../../../../actions/achievement";

import * as Util from "../../../../services/global.service";

const AchievementDetail = (props) => {
  const { t, i18n } = useTranslation();
  const achievement = useSelector((state) => state.Achievement);
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [isFormDialogOpen, openFormDialog] = React.useState(false);
  const [isSuccessDialogOpen, openSuccessDialog] = React.useState(false);
  const [errorText, setErrorText] = React.useState("");
  const [cycleSerial, setCycleSerial] = React.useState("");
  const [formData, setFormData] = React.useState({
    formEvaluateID: "",
    name: "",
    description: "",
    startDate: new Date(),
    endDate: new Date(),
    metric: "",
    metricCondition: "",
    metricUnit: "",
    metricValue: "",
    isLink: false,
    selectedGoals: [],
    selectedCompetencies: [],
  })

  const handleOpenDialog = (value) => {
    openFormDialog(value)
  };

  const handleSuccessDialog = (value) => {
    openSuccessDialog(value)
  };

  const handleEditForm = (values) => {
    dispatch(getAchievementEdit(values)).then((resp) => {
      let achievement = resp?.kpi_achievement
      let goalMetric = resp?.goal_metric
      let goalMetricUnit = resp?.goal_metric_unit
      let goals = resp.goals.map(item => {
        return item.kpi_form_goal.serial
      })
      let competencies = resp.competencies.map(item => {
        return item.kpi_form_competency.serial
      })
      let formatResp = {
        achievementSerial: achievement.serial,
        name: achievement.name,
        description: achievement.description,
        startDate: achievement.startAt,
        endDate: achievement.endAt,
        metric: goalMetric.serial,
        metricCondition: achievement.targetCondition ? achievement.targetCondition : "",
        metricUnit: goalMetricUnit.data.serial,
        metricUnitCustom: achievement.metricUnitCustom,
        metricValue: achievement.metricValue,
        isLink: achievement.isLink === "y" ? true : false,
        selectedGoals: goals,
        selectedCompetencies: competencies,
      }
      setCycleSerial(resp?.cycle?.serial)
      setFormData(formatResp)
      handleOpenDialog(true)
    })
  };

  // edit
  const handleSubmitEditForm = (values) => {
    dispatch(postAchievementEdit(values, values.achievementSerial)).then((resp) => {
      handleOpenDialog(false)
      getAchievementDetails()
      getAchievementFiles()
      handleSuccessDialog(true)
    }).catch(() => {
      setErrorText(t("label.pleaseTryAgain"));
      // handleOpenFailedMessageDialog(true);
    })
  };

  let { serial } = useParams();
  const [isAttachFilesDialogOpen, openAttachFilesDialog] = React.useState(false);

  const handleFilesDialog = (value) => {
    openAttachFilesDialog(value)
  }

  const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
  const handleOpenFailedMessageDialog = (value) => {
    setFailedMessageDialog(true);
  };
  const handleCloseFailedMessageDialog = (value) => {
    setFailedMessageDialog(false);
  };

  const [isSuccessAttachFiles, setIsSuccessAttachFiles] = React.useState(false);

  const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
  const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);


  const handleConfirmDeleteDialog = (val) => {
    openConfirmDeleteDialog(val);
  };
  const handleConfirmDeleteAchievement = () => {
    if (serial !== "") {
      dispatch(deleteAchievement(serial)).then(() => {
        openConfirmDeleteDialog(false)
        openSuccessDeleteDialog(true)
      })
    } else {
      setFailedMessageDialog(true);
    }
  };
  const setSuccessDeleteMessageDialog = () => {
    openSuccessDeleteDialog(false)
    navigate('/kpi/achievement', { replace: false });
  }


  const [discardDialog, setDiscardDialog] = React.useState(false);
  const handleDiscardDialog = (value) => {
    setDiscardDialog(value)
  };
  const handleDiscardChangeConfirm = () => {
    handleDiscardDialog(false)
    handleOpenDialog(false)
    setFormData({
      formEvaluateID: "",
      name: "",
      description: "",
      startDate: new Date(),
      endDate: new Date(),
      metric: "",
      metricCondition: "",
      metricUnit: "",
      metricValue: "",
      isLink: false,
      selectedGoals: [],
      selectedCompetencies: [],
    });
  };
  const compareInputForm = (oldVal, newVal) => {
    const checkEveryElement = (a, b) => {
      return a.every((v, i) => v === b[i]);
    }
    let isEqual = true
    if (oldVal.description !== newVal.description) isEqual = false
    if (Util.formatDate(oldVal.endDate) !== newVal.endDate) isEqual = false
    if (Util.formatDate(oldVal.startDate) !== newVal.startDate) isEqual = false
    if (oldVal.isLink !== newVal.isLink) isEqual = false
    if (oldVal.metric !== newVal.metric) isEqual = false
    if (oldVal.metricCondition !== newVal.metricCondition) isEqual = false
    if (oldVal.metricUnit !== newVal.metricUnit) isEqual = false
    if (oldVal.metricValue !== newVal.metricValue) isEqual = false
    if (oldVal.name !== newVal.name) isEqual = false
    if (oldVal.selectedGoals.length !== newVal.selectedGoals.length && !checkEveryElement(oldVal.selectedGoals, newVal.selectedGoals)) {
      isEqual = false
    }
    if (oldVal.selectedCompetencies.length !== newVal.selectedCompetencies.length && !checkEveryElement(oldVal.selectedCompetencies, newVal.selectedCompetencies)) {
      isEqual = false
    }
    return isEqual
  }

  const handleCloseDialog = (values = null) => {
    if (values) {
      let isFormEqual = compareInputForm({ ...formData }, values)
      if (isFormEqual) {
        handleOpenDialog(false);
      } else {
        handleDiscardDialog(true)
      }
    } else {
      handleOpenDialog(false);
    }

  };

  const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  function niceBytes(x) {
    let l = 0, n = parseInt(x, 10) || 0;
    while (n >= 1024 && ++l) {
      n = n / 1024;
    }
    return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
  }

  const [fileList, setFileList] = React.useState([]);

  const [successAttachmentsText, setSuccessAttachmentsText] = React.useState("")
  const uploadAttachmentsSuccess = () => {
    setSuccessAttachmentsText(t("label.uploadSuccessText"))
    setIsSuccessAttachFiles(true)
    getAchievementFilesList()
  }

  const [isSuccessDeleteFileDialogOpen, openSuccessDeleteFileDialog] = React.useState(false);
  const [isConfirmDeleteFileDialogOpen, openConfirmDeleteFileDialog] = React.useState(false);
  const [fileSerial, setFileSerial] = React.useState("");

  const handleConfirmDeleteFileDialog = (val, serial = "") => {
    openConfirmDeleteFileDialog(val)
    if (serial !== "") setFileSerial(serial)
  }

  const handleConfirmDeleteAchievementFile = () => {
    if (fileSerial !== "") {
      dispatch(deleteFileAchievement(fileSerial)).then(() => {
        getAchievementFilesList()
        openSuccessDeleteFileDialog(true)
      }).catch(() => {
        getAchievementFilesList()
      })
    } else {
      setFailedMessageDialog(true);
    }
    handleConfirmDeleteFileDialog(false)
  }

  const handleSuccessDeleteFileDialog = (val) => {
    openSuccessDeleteFileDialog(val)
  }

  useEffect(() => {
    getAchievementDetails()
    getAchievementFilesList()
  }, []);

  const [detailData, setDetailData] = React.useState({
    name: "",
    description: "",
    startDate: "",
    endDate: "",
    metric: "",
    metricCondition: "",
    metricUnit: "",
    metricValue: "",
    isLink: "",
    selectedGoals: [],
    selectedCompetencies: [],
    goalList: [],
    competencyList: []
  });
  const getAchievementDetails = () => {
    dispatch(getAchievementEdit(serial)).then((resp) => {
      let achievement = resp?.kpi_achievement
      let goalMetric = resp?.goal_metric
      let goalMetricUnit = resp?.goal_metric_unit
      let targetCondition = resp?.target_condition
      let goals = resp.goals.map(item => {
        return item.kpi_form_goal.serial
      })
      let competencies = resp.competencies.map(item => {
        return item.kpi_form_competency.serial
      })
      let formatResp = {
        serial: achievement.serial,
        name: achievement.name,
        description: achievement.description,
        startDate: achievement.startAt,
        endDate: achievement.endAt,
        metricCondition: targetCondition ? targetCondition : "-",
        metricUnit: goalMetricUnit.text,
        metricName: goalMetric.text,
        metricValue: achievement.metricValue,
        isLink: achievement.isLink === "y" ? true : false,
        selectedGoals: goals,
        selectedCompetencies: competencies,
        goalList: resp.goals,
        competencyList: resp.competencies,
        isOwner: resp.is_owner
      }
      setDetailData(formatResp)
    })
  }
  const getAchievementFilesList = () => {
    dispatch(getAchievementFiles(serial)).then((resp) => {
      let fileList = []
      if (resp.length > 0) {
        resp.sort(function (a, b) {
          const date1 = new Date(a.created_at)
          const date2 = new Date(b.created_at)
          return date1 - date2;
        })
        fileList = resp
      }
      setFileList(fileList)
    })
  }
  const openFileInNewTab = (val) => {
    dispatch(getFileDetail(val.serial)).then((resp) => {

      //forceDownloadExcel(resp.data.data)
      const newWindow = window.open(resp.data.data, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    })
  }

  async function forceDownloadExcel(url, filename = "download.xlsx") {
    console.log(url)
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download failed:", error);

      const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    }
  }

  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const useStyles = makeStyles({
    root: {
      fontSize: "16px",
    },
    abbreviation: {
      color: "#5DA196",
      background: "white",
      border: "1px solid #5DA196",
      padding: "0 10px",
      borderRadius: "5px",
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "18px!important",
    },
    expandableIcon: {
      background: "#F5F5F5",
      // padding: 3,
      width: '20px',
      height: '20px',
      borderRadius: 3,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: '.3s',
      '&.active': {
        transform: "rotate(90deg)",
      }
    },
    outlineGrayBtn: {
      // border: '1px solid #DADADA!important',
      borderRadius: '5px!important',
      color: 'black',
      height: '30px'
    },
    fillWhite: {
      '& > path': {
        stroke: '#FFFFFF'
      },
      '& g > path': {
        stroke: '#FFFFFF'
      },
    },
    plusSvg: {
      "& > path": {
        fill: "#fff",
        stroke: "#fff",
      }
    },
    statusBadge: {
      // maxWidth: "150px",
      borderRadius: "100px",
      padding: "8px 35px",
      margin: "0",
    },
    processBg: {
      background: "#E7EEF7",
    },
    processBgWhite: {
      background: "#ffffff",
      border: "1px solid #5387C6"
    },
    processText: {
      color: "#5387C6",
    },
    completedBg: {
      background: "rgba(93, 161, 150, 0.15);",
    },
    completedText: {
      color: "#5DA196",
    },
    clickable: {
      cursor: "pointer",
      transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      '&:hover': {
        color: 'rgb(65, 112, 105) !important'
      }
    },
    linkedItem: {
      cursor: "pointer",
      '&:hover': {
        "-webkit-box-shadow": "3px 3px 5px 2px rgba(0,0,0,0.2)",
        "-moz-box-shadow": "3px 3px 5px 2px rgba(0,0,0,0.2)",
        boxShadow: "3px 3px 5px 2px rgba(0,0,0,0.2)"
      }
    },
  });

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }));

  const classes = useStyles();

  const formatData = (data, defaults) => {
    if (data !== null && data !== undefined && data !== "") {
      return data;
    }
    return defaults;
  }

  const disableDel = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "no-drop",
    opacity: "0.5",
    "& > button": {
      pointerEvents: "none"
    }
  }

  const notDisableDel = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }

  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  };
  const dateFormat = (data) => {
    if (data !== undefined && data !== null && data !== "") {
      const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
      const dateTH = date.toLocaleDateString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
        year: '2-digit',
        month: 'short',
        day: 'numeric',
      })
      const timeTH = date.toLocaleTimeString(i18n.language === "th-TH" ? "th-TH" : "en-GB", { hour: '2-digit', minute: '2-digit' })
      return `${dateTH} ${timeTH} ${i18n.language === "th-TH" ? "น." : ""}`
    }
  }
  const navigate = useNavigate();
  const clickLink = (data) => {
    navigate(data, { replace: false });
  }
  return (
    <>
      <Helmet>
        <title>Achievement Detail | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.link} onClick={() => clickLink('/kpi/achievement')}>{t("achievement.label.title")}</span> / <span style={styles.end} >{t("achievement.label.titleDetail")}</span></Typography>
          </Grid>
          <Grid container>
            <Grid item md={12}>
              <Grid container item my={3} mt={0}>
                <Grid item md={6} pr={1}>
                  <Typography fontSize="36px" color="#404349" fontWeight="500">
                    {t("achievement.label.achievementDetail")}
                  </Typography>
                </Grid>
                {state?.isOwner ?? false ?
                  <Grid
                    item
                    md={6}
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-end"
                  >
                    <Box ml={1}>
                      <Button
                        variant="contained"
                        color="red"
                        sx={{
                          width: "103px",
                          height: "40px",
                          p: "0",
                          textTransform: "none",
                        }}
                        onClick={() => { handleConfirmDeleteDialog(true) }}
                      >
                        <Box
                          mr={1}
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <TrashIcon className={`${classes.fillWhite}`} />
                        </Box>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          {t("label.delete")}
                        </Box>
                      </Button>
                    </Box>
                    <Box ml={1}>
                      <Button
                        variant="contained"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textTransform: "none"
                        }}
                        onClick={() => handleEditForm(serial)}
                      >
                        <Box
                          mr={1}
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <PencilWhiteIcon />
                        </Box>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          {t("label.edit")}
                        </Box>
                      </Button>
                    </Box>
                  </Grid>
                  : null
                }
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item lg={12} md={12}>
              <Card>
                <CardContent>
                  <Grid container spacing={5} padding={1}>
                    <Grid item lg={12}>
                      <Box display="flex" alignItems="center" width="100%">
                        <Box sx={{ mr: 3 }}>
                          <Typography fontSize={20} lineHeight="22px" fontWeight="500" color="#404349">
                            {detailData.name !== "" ? detailData.name : "-"}
                          </Typography>
                        </Box>
                        <Box sx={{ width: "auto" }} flexGrow="1" display="flex">
                          {detailData.isLink ?
                            <>
                              <CheckCircleIcon
                                style={{
                                  fill: cssVariables.color.primary,
                                  marginRight: 3,
                                }}
                              ></CheckCircleIcon>
                              <Typography
                                color={cssVariables.color.primary}
                                fontWeight="500"
                              >
                                {
                                  detailData.selectedGoals.length > 0 && detailData.selectedCompetencies.length === 0 ? t("achievement.label.used.goal") :
                                    detailData.selectedGoals.length === 0 && detailData.selectedCompetencies.length > 0 ? t("achievement.label.used.competency") :
                                      detailData.selectedGoals.length > 0 && detailData.selectedCompetencies.length > 0 ? t("achievement.label.used.goalAndCompetency") : null
                                }
                              </Typography>
                            </>
                            : null}
                        </Box>
                        <Box textAlign="center">
                          <Typography variant="sub_label"> {detailData.startDate !== "" ? Util.formatDate3(detailData.startDate, i18n.language) : ""} - {detailData.endDate !== "" ? Util.formatDate3(detailData.endDate, i18n.language) : ""}</Typography>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item lg={12} sx={{ paddingTop: "20px!important" }}>
                      <Divider />
                    </Grid>
                    <Grid
                      item
                      p={2}
                      lg={12}
                      sx={{ paddingTop: "20px!important" }}
                    >
                      <Grid container spacing={5} padding={1}>
                        <Grid
                          item
                          lg={12}
                        >
                          <Typography sx={{ whiteSpace: "pre-line" }} color="#404349"> {detailData.description !== "" ? detailData.description : "-"}</Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={5} padding={1}>
                        <Grid
                          item
                          lg={12}
                        >
                          <Grid container p={0}>
                            <Grid item lg={3}>
                              <Typography variant="sub_label">
                                {t("achievement.label.metric")}
                              </Typography>
                            </Grid>
                            <Grid item lg={3}>
                              <Typography variant="sub_label">
                                {t("achievement.label.target_condition")}
                              </Typography>
                            </Grid>
                            <Grid item lg={3}>
                              <Typography variant="sub_label">
                                {t("achievement.label.value")}
                              </Typography>
                            </Grid>
                            <Grid item lg={3}>
                              <Typography variant="sub_label">
                                {t("achievement.label.unit")}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container p={0}>
                            <Grid item lg={3}>
                              <Typography sx={{ overflowWrap: "break-word" }} color="#404349">
                                {detailData.metricName ? detailData.metricName : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3}>
                              <Typography sx={{ overflowWrap: "break-word" }} color="#404349">
                                {detailData.metricCondition ? detailData.metricCondition : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3}>
                              <Typography sx={{ overflowWrap: "break-word" }} color="#404349">
                                {
                                  detailData.metricName ?
                                    detailData.metricName === "Accomplishment" || detailData.metricName === "ทำสำเร็จหรือไม่" ? Util.capitalizedString(detailData.metricValue)
                                      : detailData.metricName === "Date" || detailData.metricName === "ทำได้ภายใน End Date" ? Util.formatDate2(detailData.metricValue)
                                        : detailData.metricValue
                                    : "-"
                                }
                              </Typography>
                            </Grid>
                            <Grid item lg={3}>
                              <Typography sx={{ overflowWrap: "break-word" }} color="#404349">
                                {
                                  detailData.metricUnit !== "" ?
                                    detailData.metricName === "Value" || detailData.metricName === "ทำได้ตัวเลขตามเป้าหมาย" ? detailData.metricUnit : "-"
                                    : "-"
                                }
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid container spacing={4} mt={1}>
            <Grid item lg={6}>
              <Grid container spacing={5}>
                <Grid item lg={12}>
                  <Card className="min-height-card">
                    <CardContent>
                      {/* <Grid container p={2}>
                        <Grid item xs={5} sm={5} md={5}>
                          <Typography variant="sub_label">{ t("achievement.label.description") }</Typography> 
                        </Grid>
                        <Grid item xs={7} sm={7} md={7}>
                          <Typography>{ detailData.description !== "" ?  detailData.description : "-" }</Typography> 
                        </Grid>
                      </Grid> */}
                      <Grid container p={2}>
                        <Grid item xs={5} sm={5} md={5}>
                          <Typography variant="sub_label">{t("achievement.label.startDate")}  - {t("achievement.label.endDate")} </Typography>
                        </Grid>
                        <Grid item xs={7} sm={7} md={7}>
                          <Typography color="#404349">{detailData.startDate !== "" ? Util.formatDate2(detailData.startDate) : ""} - {detailData.endDate !== "" ? Util.formatDate2(detailData.endDate) : ""}</Typography>
                        </Grid>
                      </Grid>
                      <Grid container p={2}>
                        <Grid item xs={5} sm={5} md={5}>
                          <Typography variant="sub_label">{t("achievement.label.goalsAndCompetenciesSupport")}</Typography>
                        </Grid>
                        <Grid item xs={7} sm={7} md={7}>
                          <Typography color="#404349">{detailData.isLink ? "Yes" : "No"}</Typography>
                        </Grid>
                      </Grid>
                      <Grid container p={2}>
                        <Grid item xs={5} sm={5} md={5}>
                          <Typography variant="sub_label">{t("achievement.label.linkedItems")}</Typography>
                        </Grid>
                        <Grid item xs={7} sm={7} md={7}>
                          {
                            detailData.goalList.length > 0 ?
                              detailData.goalList.map(item =>
                                <React.Fragment key={item.serial}>
                                  <Paper
                                    sx={{ width: "100%", p: 1, display: "flex", alignItems: "center", mb: 1.5 }}
                                    elevation={2}
                                    classes={{ root: classes.linkedItem }}
                                    onClick={() => openInNewTab(`/kpi/mygoal-detail/${item.kpi_form_goal.serial}`)}
                                  >
                                    <Icon sx={{ color: "#74C1ED" }}> {item?.kpi_goal_category?.icon ?? ""} </Icon>
                                    <BootstrapTooltip title={item?.kpi_goal?.name ?? "-"} placement="top">
                                      <Typography color="#404349" sx={{ ml: 2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item?.kpi_goal?.name ?? "-"}</Typography>
                                    </BootstrapTooltip>
                                    <Box sx={{ marginLeft: "auto", background: "#F5F5F5", borderRadius: "3px", p: "4px", width: "30px", height: "30px" }}>
                                      <ArrowForwardIcon />
                                    </Box>
                                  </Paper>
                                </React.Fragment>
                              )
                              : null
                          }
                          {
                            detailData.competencyList.length > 0 ?
                              detailData.competencyList.map(item =>
                                <React.Fragment key={item.serial}>
                                  <Paper
                                    sx={{ width: "100%", p: 1, display: "flex", alignItems: "center", mb: 1.5 }}
                                    elevation={2}
                                    key={item.serial}
                                    classes={{ root: classes.linkedItem }}
                                    onClick={() => openInNewTab(`/kpi/competency/detail/${item?.kpi_form_competency?.serial}`)}
                                  >
                                    <Icon sx={{ color: "#FA9349" }}> {item?.kpi_competency_type?.icon ?? ""} </Icon>
                                    <BootstrapTooltip title={item?.kpi_competency_content?.name ?? "-"} placement="top">
                                      <Typography color="#404349" sx={{ ml: 2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item?.kpi_competency_content?.name ?? "-"}</Typography>
                                    </BootstrapTooltip>
                                    <Box sx={{ marginLeft: "auto", background: "#F5F5F5", borderRadius: "3px", p: "4px", width: "30px", height: "30px" }}>
                                      <ArrowForwardIcon />
                                    </Box>
                                  </Paper>
                                </React.Fragment>
                              )
                              : null
                          }
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={6}>
              <Grid container spacing={1}>
                <Grid item lg={12}>
                  <Card className="min-height-card">
                    <CardContent>
                      <Grid container pt={0} pb={2}>
                        <Grid item md={6} pr={1}>
                          <Typography color="#404349" fontSize={20} fontWeight="500" sx={{ paddingTop: "10px", paddingBottom: "10px" }}>
                            {t("achievement.label.attachFiles")} ({fileList.length})
                          </Typography>
                        </Grid>
                        {detailData?.isOwner && state?.isOwner ?
                          <Grid
                            item
                            md={6}
                            display="flex"
                            alignItems="center"
                            justifyContent="flex-end"
                          >
                            <Box ml={1} p={0}>
                              <Button size="small" variant="outlined" color="black" className={classes.outlineGrayBtn} onClick={() => handleFilesDialog(true)}>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                >
                                  <PlusIcon />
                                  <Box style={{ marginLeft: "3px", fontSize: "15px", textTransform: "none" }}>
                                    {t("label.add")}
                                  </Box>
                                </Box>
                              </Button>
                            </Box>
                          </Grid>
                          : null
                        }
                      </Grid>
                      {
                        fileList.length > 0 ?
                          [...fileList].map((item, index) => {
                            return <React.Fragment key={index}>
                              <Grid container mt={1} >
                                <Grid item xs={12}>
                                  <Paper elevation={2}>
                                    <Grid container item p={2}>
                                      <Grid
                                        item
                                        display="flex"
                                        alignItems="center"
                                        md={1}
                                      >
                                        <Box ml={1} p={0} sx={{ width: "33px", height: "33px" }}>
                                          {item.mime_type === "application/pdf" ?
                                            <PdfIcon /> :
                                            item.mime_type === "image/png" ?
                                              <PngIcon /> :
                                              item.mime_type === "image/jpeg" ?
                                                <JpgIcon /> : <NullIcon />
                                          }
                                        </Box>
                                      </Grid>
                                      <Grid item md={9} pr={1} onClick={() => openFileInNewTab(item)}>
                                        <Grid container item p={0}>
                                          <Grid item pr={1} sx={{ width: "100%" }}>
                                            <Typography variant="h5" color="#404349" sx={{ cursor: "pointer", wordBreak: "break-all" }}>
                                              {item.name}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                        <Grid container item p={0}>
                                          <Grid item pr={1}>
                                            <Typography variant="sub_label">
                                              {niceBytes(item.size)}
                                            </Typography>
                                            <Typography variant="sub_label" pl={1} pr={1}>
                                              |
                                            </Typography>
                                            <Typography variant="sub_label">
                                              {dateFormat(item.created_at)}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      {detailData?.isOwner && state?.isOwner ?
                                        <Grid
                                          item
                                          display="flex"
                                          alignItems="center"
                                          flexDirection="row-reverse"
                                          md
                                        >
                                          <Box ml={1} p={0} className="clickable" onClick={() => handleConfirmDeleteFileDialog(true, item.serial)}>
                                            <TrashIcon />
                                          </Box>
                                        </Grid>
                                        : null
                                      }
                                    </Grid>
                                  </Paper>
                                </Grid>
                              </Grid>
                            </React.Fragment>
                          }
                          ) :
                          state?.isOwner ?
                            (<Grid container spacing={4} mt={6}>
                              <Grid item lg={12} md={12}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  flexDirection="column"
                                  p={1}
                                >
                                  <Box>
                                    <img src={fileBrowser} alt="browser" />
                                  </Box>
                                  <Box>
                                    <Typography variant="sub_label">{t("label.noData")}</Typography>
                                  </Box>
                                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                                    <Typography
                                      classes={{ root: classes.clickable }}
                                      style={{ color: "#5DA196", fontWeight: "500", textDecoration: "underline" }}
                                      onClick={() => handleFilesDialog(true)}
                                      component="div"

                                    >
                                      {t("label.clickHere")}
                                    </Typography>
                                    <Typography sx={{ ml: 1 }} variant="sub_label">
                                      {t("achievement.label.toAdd")}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Grid>
                            </Grid>)
                            :
                            (<Grid container spacing={4} mt={6}>
                              <Grid item lg={12} md={12}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  flexDirection="column"
                                  p={1}
                                >
                                  <Box>
                                    <img src={fileBrowser} alt="browser" />
                                  </Box>
                                  <Box>
                                    <Typography variant="sub_label">{t("portfolio.label.nodata")}</Typography>
                                  </Box>
                                </Box>
                              </Grid>
                            </Grid>)
                      }
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Dialog open={isFormDialogOpen} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="lg" PaperProps={{ sx: { padding: '10px' } }} onBackdropClick={() => { }}>
          <DialogTitle id="form-add-dialog-title" fontSize={24} color="#404349">
            {t("achievement.label.editAchievement")}
            {/* <Box sx={{ position: "absolute", right: 0, margin: "30px 20px 0  0", top: 0 }} className="clickable" trash={true} onClick={() => handleOpenDialog(false)}><img src={CloseIcon} alt="browser" /></Box> */}
          </DialogTitle>
          <DialogContent px={0} pb={0}>
            <Divider />
            <InputForm
              close={handleCloseDialog}
              edit={handleSubmitEditForm}
              data={formData}
              form={cycleSerial}
              type="edit"
            ></InputForm>
          </DialogContent>
        </Dialog>
        {/*  */}
        <SimpleDialog open={isSuccessDialogOpen} setValue={handleSuccessDialog} text={t("achievement.label.dialog.editAchievement")} />
        {/* delete confirmation dialog */}
        <ConfirmDialog open={isConfirmDeleteDialogOpen} doConfirm={handleConfirmDeleteAchievement} trash={true} setValue={handleConfirmDeleteDialog} title={t("achievement.label.dialog.confirmDeleteTitle")} text={t("achievement.label.dialog.confirmDeleteText")} />
        <SimpleDialog open={isSuccessDeleteDialogOpen} setValue={setSuccessDeleteMessageDialog} text={t("achievement.label.dialog.deleteAchievement")} />
        {/* delete comfirmation attachment file dialog */}
        <ConfirmDialog open={isConfirmDeleteFileDialogOpen} doConfirm={handleConfirmDeleteAchievementFile} trash={true} setValue={handleConfirmDeleteFileDialog} title={t("achievement.label.dialog.confirmDeleteAttachmentTitle")} text={t("achievement.label.dialog.confirmDeleteAttachmentText")} />
        <SimpleDialog open={isSuccessDeleteFileDialogOpen} setValue={handleSuccessDeleteFileDialog} text={t("achievement.label.dialog.deleteAttachment")} />

        <AttachFilesDialog open={isAttachFilesDialogOpen} setValue={openAttachFilesDialog} submitFiles={() => uploadAttachmentsSuccess()} value={fileList}></AttachFilesDialog>
        <MessageDialog open={openFailedMessageDialog} setValue={handleCloseFailedMessageDialog} type="fail" title={t("achievement.label.dialog.failed")} text={errorText} />

        <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t("achievement.label.dialog.discardTitle")} text={t("achievement.label.dialog.discardText")} />

        <MessageDialog open={isSuccessAttachFiles} setValue={() => setIsSuccessAttachFiles(false)} title={t("label.success_simple")} text={successAttachmentsText} />

      </Box>
    </>
  );
};
export default AchievementDetail;
